import { ContactInfo } from './../../Models/contact';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Int64Updater } from 'src/app/Helpers/key-value';
import { Variables } from 'src/app/Helpers/variables';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = environment.apiUrl;
  }

  getContacts(page: number, size: number, contactid: number, filter: string, groupid: number, type: string): Observable<any> {
    const v = new Variables();
    let val: string | null;
    val = localStorage.getItem('mg');
    const gps = CryptoJS.AES.decrypt(val as string, v.pass).toString(CryptoJS.enc.Utf8).toString();

    const url = this.apiUrl + '/api/contact/' + page + '/' + size + '/' + contactid
     + '/' + filter + '/' + type + '/' + groupid + '/' + gps + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postContact(contact: ContactInfo): Observable<any> {
    const v = new Variables();
    let val: string | null;
    val = localStorage.getItem('mg');
    const gps = CryptoJS.AES.decrypt(val as string, v.pass).toString(CryptoJS.enc.Utf8).toString();
    contact.Groups = gps;
    return this.httpclient.post(this.apiUrl + '/api/contact', contact)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  putContact(value: Int64Updater): Observable<any> {
    const v = new Variables();
    let val: string | null;
    val = localStorage.getItem('mg');
    const gps = CryptoJS.AES.decrypt(val as string, v.pass).toString(CryptoJS.enc.Utf8).toString();
    value.AdditionalValues2 = gps;
    return this.httpclient.put(this.apiUrl + '/api/contact/' + value.Id, value)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteContact(value: Int64Updater): Observable<any> {
    const v = new Variables();
    let val: string | null;
    val = localStorage.getItem('mg');
    const gps = CryptoJS.AES.decrypt(val as string, v.pass).toString(CryptoJS.enc.Utf8).toString();
    value.AdditionalValues2 = gps;
    return this.httpclient.put(this.apiUrl + '/api/contact/delete' + value.Id, value)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any): any {
    throw error;
    return error;
  }

}
